export default __webpack_public_path__ + "static/bgp-1-592af64ecef7aa9c9683120555a788ca.png";